/**
 * English strings for the `shell` namespace: the app frame — header, nav,
 * workspace picker, error screen, toasts. French is typed against this file.
 */
const shell = {
  routeError: {
    title: "Something went wrong on this page",
    body: "The rest of the app still works. Reload to try this page again — if it keeps happening, tell us what you were doing.",
    reload: "Reload the page",
    home: "Go to the library",
  },
  nav: {
    home: "Home",
    library: "Library",
    studio: "Studio",
    search: "Search",
    people: "People",
    settings: "Settings",
    account: "Your account",
    backOffice: "Back-office",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    signOut: "Sign out",
  },
  theme: {
    light: "Light theme",
    dark: "Dark theme",
    system: "System theme",
  },
  workspace: {
    select: "Select workspace",
    noneTitle: "No workspace yet",
    noneBody:
      "Your account isn't part of a workspace. If you were invited, open the link in your invitation email.",
    chooseTitle: "Choose a workspace",
    chooseBody: "Your account belongs to more than one.",
  },
  toast: {
    dismiss: "Dismiss",
  },
  errorState: {
    title: "Something went wrong",
    body: "We could not load this.",
  },
  /** For a response that carried no error body of ours — see `httpMessage`. */
  http: {
    unauthorized: "Your session has expired. Sign in again.",
    forbidden: "You do not have permission to do that.",
    notFound: "That is no longer there.",
    tooManyRequests: "Too many requests. Wait a moment and try again.",
    server: "Our end had a problem. Try again in a moment.",
    rejected: "That request was not accepted.",
  },
} as const;

export default shell;
